import { $api } from "../generated/client";

export default function useShopOverrideRules(shopId?: string | null) {
  return $api.useQuery(
    "get",
    "/shops/{shopId}/override-rules",
    {
      params: { path: { shopId: shopId! } },
    },
    {
      enabled: !!shopId,
    },
  );
}
